import React, { useState } from "react";
import { useQuery } from "react-query";
import { useSnackbar } from "notistack";
import classNames from "classnames";

import { Column, Row } from "components/Layout";
import IntervalBar from "components/IntervalBar/IntervalBar";
import WeatherWidget from "components/WeatherWidget";
import Charts from "./Charts";
import Tables from "./Tables";
import styles from "./_charts.module.scss";

import { useGetDevices } from "service/ProjectService";
import {
	getDeviceTodayData, getDeviceWeeklyData, getDeviceMonthlyData, getDeviceCustomData,
} from "service/RadarpestService";
import { getErrorMessage } from "service/Client";


export default function IntervalPageRadarpest({type, display}) {

	const [deviceId, setDeviceId] = useState();
	const [interval, setInterval] = useState("weekly");
	const [startDate, setStartDate] = useState();
	const [endDate, setEndDate] = useState();
	const {enqueueSnackbar} = useSnackbar();
	let { devices } = useGetDevices()

	function showError(e) {
		enqueueSnackbar(getErrorMessage(e), { variant: "error" });
	}

	let { data } = useQuery(['data', { deviceId, interval, startDate, endDate }], () => {
		let promise
		
		if (!deviceId) return;
		if (interval === "daily") {
			promise = getDeviceTodayData(deviceId);
		} else if (interval === "weekly") {
			promise = getDeviceWeeklyData(deviceId);
		} else if (interval === "monthly") {
			promise = getDeviceMonthlyData(deviceId);
		} else if (startDate !== null && endDate !== null) {
			promise = getDeviceCustomData(deviceId, startDate.format("DD-MM-YYYY"), endDate.format("DD-MM-YYYY"));
		}
		return promise
	}, {
		enabled: !!deviceId && (interval !== 'custom' || (!!startDate && !!endDate)),
		initialData: [],
		onError: showError,
		refetchInterval: (interval === 'daily') ? 10000 : false,
	})

	if (devices.length === 0) return null
	if (!deviceId) {
		setDeviceId(devices[0].deviceId)
	}

	let deviceObj = devices.find(d => d.deviceId === deviceId);

	return (
		<div className={classNames("animated", "fadeIn", styles.box)}>
			<IntervalBar
				devices={devices.map(d => ({ device: d.deviceId, label: d.label || d.deviceId }))}
				device={deviceId}
				setDevice={setDeviceId}
				interval={interval}
				setInterval={setInterval}
				startDate={startDate}
				setStartDate={setStartDate}
				endDate={endDate}
				setEndDate={setEndDate}
				showDaily={false}
				showForecastBtn={false}
			/>

			{
				display === "charts" &&
					<>
						<Charts data={data} type={type} />
						{deviceObj && deviceObj.lat && deviceObj.lng && <Row>
							<Column>
								<div className={styles.weatherWidgetContainer}>
									<WeatherWidget
										lat={deviceObj.lat}
										lng={deviceObj.lng}
										type="forecast"
									/>
								</div>
							</Column>
						</Row>}
					</>
			}
			{
				display === "table" && <Tables data={data} type={type}/>
			}
		</div>
	);
}
